import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://bookiapp.com';

interface PageSeoProps {
  /** Route path, e.g. '/pricing'. */
  path: string;
  title: string;
  description: string;
}

/**
 * Per-page <head> tags for the public marketing pages.
 *
 * Without these a page inherits index.html's defaults — the homepage title and
 * `canonical: https://bookiapp.com` — which tells Google the page is a copy of
 * the homepage. The URL always ends in a slash because Cloudflare Pages
 * redirects /path → /path/ (308), so that's the URL Googlebot settles on; the
 * sitemap advertises the same form.
 */
export function PageSeo({ path, title, description }: PageSeoProps) {
  const url = `${SITE_URL}${path.endsWith('/') ? path : `${path}/`}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
